var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLaser = function SvgLaser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 2.821v2.286a2.286 2.286 0 0 0 2.286 2.286h11.428A2.286 2.286 0 0 0 20 5.107V2.821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.287 7.393v1.143a2.286 2.286 0 0 0 2.286 2.285h6.857a2.286 2.286 0 0 0 2.286-2.285V7.393M12 10.821v4M15.43 17.107h1.714M13.713 18.25l1.714 1.714M12 19.393v2.285M10.285 18.25 8.57 19.964M8.572 17.107H6.857"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 17.679a.572.572 0 1 0 0-1.144.572.572 0 0 0 0 1.144"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLaser);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;